import * as React from 'react';
import {BodyWrapper} from '../components/BodyWrapper';
import {TerminalFrame} from '../components/TerminalFrame';
import {setTitle} from '../utils/title';
import {pingPageView} from '../utils/analytics';
import styled from 'styled-components';
import {Colors, Fonts} from '../utils/colors';

export const Page404 = () => {
  setTitle('404')
  pingPageView()
  return (
    <BodyWrapper>
      <Wrap>
        <TerminalFrame title="404">
          <Line>&gt; you lost?</Line>
        </TerminalFrame>
      </Wrap>
    </BodyWrapper>
  )
};

const Wrap = styled.div`
  max-width: 420px;
  margin: 0 auto;
`;

const Line = styled.p`
  margin: 0;
  color: ${Colors.destructGreen};
  font-family: ${Fonts.mono};
`;
